import { render, staticRenderFns } from "./TrainingRecordEdit.vue?vue&type=template&id=83cdc5c0"
import script from "./TrainingRecordEdit.vue?vue&type=script&lang=js"
export * from "./TrainingRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports